export default __webpack_public_path__ + "files/digitalturbine.png";